module.exports = __webpack_public_path__ + "img/PEC9000_Z.90eda4d9.png";